function updateDeviceCalibrationForm(device_uid) {
    let url = "/device/" + device_uid + "/controller/stack/serial/";
    let i = 0;
    setInterval(function () {
        if (i < 1) {
            $.ajax({
                type: "GET",
                url: url,
                success: function (response) {
                    let stacks = response.stacks;
                    for (let stack in stacks) {
                        let serial_id = stacks[stack]['inner_id']
                        if (serial_id === "") {
                            let controller_serial = stack["inner_id"];
                            if (controller_serial) {
                                document.getElementById("id_controller_serial_" + stack).value = controller_serial;
                            }
                        }
                    }
                    $("#modal-serials-list").empty();
                    for (let stack in stacks) {
                        $("#modal-serials-list").append("<p>" + stacks[stack]['inner_id'] + "</p>");
                    }
                },
            });
            i++;
        }
    }, 500);
}


function calibrationReceiveSerials(device_uid) {
    let url = "/device/" + device_uid + "/controller/receive/serials";

    $.ajax({
        type: "PUT",
        url: url,
        data: {
            "csrfmiddlewaretoken": $("input[name='csrfmiddlewaretoken']").prop("value"),
        },
        success: function (response) {
            let title = response.title;
            let message = response.message;
            $("#modal-header").text(title).attr("style", "color: green; text-align: center;");
            $("#modal-command").text(message).attr("style", "color: green; text-align: center;");
            $('#message').modal("show");

            setTimeout(function () {
                $('#message').modal("hide");
            }, 2000);
        },
        error: function (response) {
            let title = response.responseJSON.title;
            let message = response.responseJSON.message;
            $("#modal-header").text(title).attr("style", "color: red; text-align: center;");
            $("#modal-command").text(message).attr("style", "color: red; text-align: center;");
            $('#message').modal("show");

            setTimeout(function () {
                $('#message').modal("hide");
            }, 2000);
        }
    })
}

function getStackNumber(counter) {
    return document.querySelectorAll('[name="stack_number"]')[counter - 1].value;
}

function getInnerId(counter) {
    let stack_inner_id = document.querySelectorAll('[name="inner_id"]')[counter - 1].value;
    if (!stack_inner_id) {
        alert('Please fill the fields Stack & Inner ID');
        return null;
    }
    return stack_inner_id;
}

function handleTestOpenCell(counter, device_id) {
    let stack = getStackNumber(counter);
    let stack_inner_id = getInnerId(counter);

    if (stack_inner_id === null) {
        let errorElement = document.getElementById('error-message-' + counter);
        if (errorElement) {
            errorElement.style.display = 'block';
        }
        return;
    }
    let errorElement = document.getElementById('error-message-' + counter);
    if (errorElement) {
        errorElement.style.display = 'none';
    }
    testOpenCell('0', stack, device_id, stack_inner_id);
}


function saveCalibrationForm(device_uid) {
    let url = "/device/" + device_uid + "/controller/stack/serial/";

    let stacks = document.getElementsByName("stack_number");
    let serials = document.getElementsByName("inner_id");

    let _stacks = [];
    let _serials = [];

    for (let stack in stacks) {
        if (stacks[stack].value) {
            _stacks.push(stacks[stack].value)
        }
    }

    for (let serial in serials) {
        if (serials[serial].value) {
            _serials.push(serials[serial].value)
        }
    }
    console.log('Has duplicates in serials?', _serials.length > new Set(_serials).size);

    if (_serials.length > new Set(_serials).size) {
        alert('There are duplicate serials in the form.');
        return;
    }

    $.ajax({
        type: "POST",
        url: url,
        data: {
            "csrfmiddlewaretoken": $("input[name='csrfmiddlewaretoken']").prop("value"),
            "stacks": JSON.stringify(_stacks),
            "inner_ids": JSON.stringify(_serials)
        },
        success: function (response) {
            let title = response.title;
            let message = response.message;
            $("#modal-header").text(title).attr("style", "color: green; text-align: center;");
            $("#modal-command").text(message).attr("style", "color: green; text-align: center;");
            $('#message').modal("show");

            setTimeout(function () {
                $('#message').modal("hide");
                location.reload(true);
            }, 2000);
        },
        error: function (response) {
            let title = response.responseJSON.title;
            let message = response.responseJSON.message;
            $("#modal-header").text(title).attr("style", "color: red; text-align: center;");
            $("#modal-command").text(message).attr("style", "color: red; text-align: center;");
            $('#message').modal("show");

            setTimeout(function () {
                $('#message').modal("hide");
            }, 3000);
        }
    })
}